import { ensureTrailingSlash } from '../utils/urlHelper';
import ApiServiceBase from './apiServiceBase';
import { ISaveUserSettingRequest } from './models/user';
import { AxiosRequestConfig, Method } from 'axios';

export default class UserApiService extends ApiServiceBase {
	constructor(basePath: string) {
		super(basePath);
	}

	protected createBaseRequest(): AxiosRequestConfig {
		const baseConfig = super.createBaseRequest();
		return {
			...baseConfig,
			baseURL: ensureTrailingSlash(baseConfig.baseURL) + '/services/user'
		};
	}

	public async saveUserSetting(data: ISaveUserSettingRequest): Promise<void> {
		const request = {
			url: '/SaveUserSettings',
			method: 'post' as Method,
			data,
			...this.createBaseRequest()
		};

		const response = await super.sendAsync<void>(request);
		this.throwIfFailedResponse(response, localize('Error while saving user settings.'));
	}
}
